import { useMemo, type FC } from "react";

import NotificationIcon from "@shared/frontend/components/NotificationIcon";

import type { OrganizationManagerNotification } from "@entities";
import NotificationActions from "@shared/frontend/components/NotificationActions";
import dayjs from "dayjs";

interface OneNotificationProps {
  notification: OrganizationManagerNotification;
}

export const OneNotification: FC<OneNotificationProps> = (props) => {
  const { notification } = props;

  const notificationCreatedTime = useMemo(() => {
    const createdAt = dayjs(notification.createdAt);
    const today = dayjs().startOf("day");
    const yesterday = dayjs().subtract(1, "day").startOf("day");

    if (createdAt.isSame(today, "day")) {
      return createdAt.format("HH:mm");
    } else if (createdAt.isSame(yesterday, "day")) {
      return "אתמול";
    } else {
      return createdAt.format("DD.MM");
    }
  }, [notification.createdAt.getTime()]);

  return (
    <div className="notification-container">
      <div className="icon-background">
        <NotificationIcon notification={notification as any} />
      </div>
      <div className="text-container">
        <div className="upper">
          <p className="type">{notification.title}</p>
          <NotificationActions notification={notification as any} />
        </div>
        <p className="text">{notification.content}</p>
      </div>
      <span className="notification-created-time">
        {notificationCreatedTime}
      </span>
    </div>
  );
};
